export default {
  member: 'Member',
  points: 'Points',
};
